import React, { useEffect } from 'react';
import 'materialize-css/dist/css/materialize.min.css';
import 'materialize-css/dist/js/materialize.min.js';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Banner from './Components/Banner/Banner';
import TechMain from './Components/TechMain/TechMain';
import CarouselSlider from './Components/Clinica/Clinica';
import Depoimentos from './Components/Depoimentos/Depoimentos';
import Conversa from './Components/Conversa/Conversa';
import Procedimentos from './Components/Procedimentos/Procedimentos';
import Agendamento from './Components/Banner-Agendamentos/BanAgendamentos';
import Footer from './Components/Footer/Footer';
import ScrollToTop from './Components/ScrollToTop';
import Navbar from './Components/Navbar/Menu';
import PageContato from './Components/Page-Contato/PageContato';
import CookieBanner from './Components/Cookies/Cookies';
import Consultorio from './Pages/Consultorio/Consultorio';
import Sobre from './Pages/Sobre/Sobre';
import Contato from './Pages/Contato/Contato';
import Corpo from './Pages/Corpo/Corpo';
import Face from './Pages/Face/Face';
import Mamas from './Pages/Mamas/Mamas';
import Reparadoras from './Pages/Reparadoras/Reparadoras';
import Intimas from './Pages/Intimas/Intimas';
import Privacidade from './Pages/Privacidade/Privacidade';
import Tecnologias from './Pages/Tecnologias/Tecnologias';
import './Components/App/App.css';


const fundo = '/images/fundo/fundo.webp'; 

function App() {
  useEffect(() => {
    window.scrollTo(0, 0); 
    window.scrollTo(0, 0); 
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/icon?family=Material+Icons&display=block';
    document.head.appendChild(link);
  }, []);

  return (
    <Router>
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={
          <>
            <div id="banner">
              <Banner />
            </div>
            <div id="tech">
              <TechMain />
            </div>
           
            <div id="procedimentos">
              <Procedimentos />
            </div>
            <div id="clinica" className="clinica-fundo" style={{ backgroundImage: `url(${fundo})` }}>
              <CarouselSlider />
            </div>
            <div id="depoimentos">
              <Depoimentos />
            </div>
            <div id='conversa'>
              <Conversa />
            </div>
            <div id="banner-agendamento">
              <Agendamento />
            </div>
            <div id="footer">
              <Footer />
            </div>
            <div>
              <CookieBanner />
            </div>
          </>
        } />

        <Route path="/consultorio" element={<Consultorio />} />
        <Route path="/corpo" element={<Corpo />} />
        <Route path="/face" element={<Face />} />
        <Route path="/mamas" element={<Mamas />} />
        <Route path="/reparadoras" element={<Reparadoras />} />
        <Route path="/intimas" element={<Intimas />} />
        <Route path="/contato" element={<Contato />} />
        <Route path="/sobre" element={<Sobre />} />
        <Route path="/politica-de-privacidade" element={<Privacidade />} />
        <Route path="/tecnologias" element={<Tecnologias />}/>

      </Routes>
    </Router>
  );
}

export default App;